export default "__VITE_ASSET__mqW4R2dm__"